import script from "./BillingBox.vue?vue&type=script&setup=true&lang=js"
export * from "./BillingBox.vue?vue&type=script&setup=true&lang=js"

import "./BillingBox.vue?vue&type=style&index=0&id=30ed150f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026_previous\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30ed150f"]])

export default __exports__